import {Session} from 'com/gongxigames/math/core/game/session/Session';
import {ServerMessage, Xhr} from '@gongxigames/framework/slot';
import {PPRequest} from '@gongxigames/framework/integrations/pariplay/request/PPRequest';
import {PPGetBalanceResponse} from '@gongxigames/framework/integrations/pariplay/response/PPGetBalanceResponse';
import {PPGameClientWrapper} from '@gongxigames/framework/integrations/pariplay/PPGameClientWrapper';

export class PPGetBalanceRequest extends PPRequest<PPGetBalanceResponse> {
    protected getURL(): string {
        return this.config.RgsUrl + '/client/' + this.config.BalanceURL;
    }

    protected processResponse(data: any): void {
        this.response = new PPGetBalanceResponse(data);

        if (this.isError()) {
            this.on_error && this.on_error(data);
        } else {
            this.callback(data);
        }
    }

    protected getParams(): string {
        const data: any = {};

        data.PlayerTokenId = this.config.playerTokenID;

        return Xhr.objectToKeyValue(data);
    }

    public process(wrapper: PPGameClientWrapper, response: ServerMessage): ServerMessage[] {
        const session: Session = wrapper.client.getSession();
        const balance = this.response.getBalance() >= 0 ? this.response.getBalance() : -1;

        session.getPlayer().setBalance(balance);

        return null!;
    }

    public getBalance(): number {
        return this.response.getBalance();
    }

    public getBalanceMessage(): ServerMessage {
        const msg: ServerMessage = new ServerMessage();

        msg.topic = ServerMessage.TOPIC_BALANCEUPDATE;
        msg.data = new Object();
        msg.data.balance = this.response.getBalance();

        return msg;
    }
}
